import React, { useState } from 'react';
import leftarrow from '../../../../../../assets/arrow-right (2).svg';
import rightarrow from '../../../../../../assets/arrow-right (3).svg';
import "./UsersPopupPagination.css"

type UsersPopupPaginationProps = {
  currentPopupPage: number;
  totalPopupPages: number;
  totalPopupItems: number;
  onPageChange: (page: number) => void;
}

const UsersPopupPagination = ({ currentPopupPage, totalPopupPages, totalPopupItems, onPageChange }: UsersPopupPaginationProps) => {
  const [goToPage, setGoToPage] = useState('');
  const handlePageChange = (page: number) => {
    if (page !== currentPopupPage && page > 0 && page <= totalPopupPages) {
      onPageChange(page);
    }
  };

  const handlePreviousClick = () => {
    if (currentPopupPage > 1) {
      const nextPage = currentPopupPage - 1;
      onPageChange(nextPage);
    }
  };

  const handleNextClick = () => {
    if (currentPopupPage < totalPopupPages) {
      onPageChange(currentPopupPage + 1);
    }
  };
  const handleInputChange = (e:any) => {
    setGoToPage(e.target.value);
  };
  const handleKeyPress = (e:any) => {
    if (e.key === 'Enter') {
      const pageNumber = parseInt(goToPage);
      if (!isNaN(pageNumber) && pageNumber !== currentPopupPage && pageNumber > 0 && pageNumber <= totalPopupPages) {
        onPageChange(pageNumber);
        setGoToPage('');
      }
    }
  };

  const renderPageNumbers = () => {
    const pageNumbers = [];
  
    // Always show the first page number
    pageNumbers.push(
      <div
        key={1}
        className={`popuppagination-number ${currentPopupPage === 1 ? 'active' : ''}`}
        onClick={() => handlePageChange(1)}
      >
        1
      </div>
    );
  
    // Logic to determine placement of ellipsis and other page numbers
    if (totalPopupPages > 1) {
      if (totalPopupPages < 5) {
        // Show all page numbers directly
        for (let i = 2; i <= totalPopupPages; i++) {
          pageNumbers.push(
            <div
              key={i}
              className={`popuppagination-number ${currentPopupPage === i ? 'active' : ''}`}
              onClick={() => handlePageChange(i)}
            >
              {i}
            </div>
          );
        }
      } else {
        // Determine the segment to display based on currentPopupPage
        if (currentPopupPage <= 3) {
          // Show pages 2, 3, 4 and ellipsis if more pages
          for (let i = 2; i <= 4; i++) {
            pageNumbers.push(
              <div
                key={i}
                className={`popuppagination-number ${currentPopupPage === i ? 'active' : ''}`}
                onClick={() => handlePageChange(i)}
              >
                {i}
              </div>
            );
          }
          if (totalPopupPages > 5) {
            pageNumbers.push(
              <div key="ellipsis" className="popuppagination-number ellipsis">
                ..
              </div>
            );
          }
          pageNumbers.push(
            <div
              key={totalPopupPages}
              className={`popuppagination-number ${currentPopupPage === totalPopupPages ? 'active' : ''}`}
              onClick={() => handlePageChange(totalPopupPages)}
            >
              {totalPopupPages}
            </div>
          );
        } else if (currentPopupPage >= totalPopupPages - 2) {
          // Show the last 4 pages and ellipsis if more than 4 pages
          pageNumbers.push(
            <div
              key={1}
              className={`popuppagination-number ${currentPopupPage === 1 ? 'active' : ''}`}
              onClick={() => handlePageChange(1)}
            >
              2
            </div>
          );
          if (totalPopupPages > 5) {
            pageNumbers.push(
              <div key="ellipsis" className="popuppagination-number ellipsis">
                ..
              </div>
            );
          }
          for (let i = totalPopupPages - 3; i <= totalPopupPages; i++) {
            pageNumbers.push(
              <div
                key={i}
                className={`popuppagination-number ${currentPopupPage === i ? 'active' : ''}`}
                onClick={() => handlePageChange(i)}
              >
                {i}
              </div>
            );
          }
        } else {
          // Show pages around the current page with ellipsis on both ends
          pageNumbers.push(
            <div
              key={1}
              className={`popuppagination-number ${currentPopupPage === 1 ? 'active' : ''}`}
              onClick={() => handlePageChange(1)}
            >
              2
            </div>
          );
          if (currentPopupPage > 4) {
            pageNumbers.push(
              <div key="ellipsis-start" className="popuppagination-number ellipsis">
                ..
              </div>
            );
          }
          for (let i = Math.max(currentPopupPage - 1, 2); i <= Math.min(currentPopupPage + 1, totalPopupPages - 1); i++) {
            pageNumbers.push(
              <div
                key={i}
                className={`popuppagination-number ${currentPopupPage === i ? 'active' : ''}`}
                onClick={() => handlePageChange(i)}
              >
                {i}
              </div>
            );
          }
          if (currentPopupPage < totalPopupPages - 3) {
            pageNumbers.push(
              <div key="ellipsis-end" className="popuppagination-number ellipsis">
                ..
              </div>
            );
          }
          pageNumbers.push(
            <div
              key={totalPopupPages}
              className={`popuppagination-number ${currentPopupPage === totalPopupPages ? 'active' : ''}`}
              onClick={() => handlePageChange(totalPopupPages)}
            >
              {totalPopupPages}
            </div>
          );
        }
      }
    }
  
    return pageNumbers;
  };
  
  
  
  
  
  

  const renderPaginationInfo = () => {
    const startItem = (currentPopupPage - 1)+ 1;
    const endItem = Math.min(totalPopupPages);

    return `${startItem}-${endItem} of ${totalPopupItems}`;
  };
  

  return (
    <div style={{    display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding:"6px 14px",
      width: "660px",

      borderRadius: "6px",
      background: "#F4F8FE"}} className="popuppagination-container">
        <div className="popuppagination-info">
        {renderPaginationInfo()}
      </div>
      <div className='middle-container'>
      <div className="popuppagination-controls">
        <div
          className={`popuppagination-control ${currentPopupPage === 1 ? 'disabled' : ''}`}
          onClick={handlePreviousClick}
        >
          <img className='left-arrow' src={leftarrow} alt="leftarrow" />
          {/* <span style={{color: "#4B628A",fontFamily: "Inter", fontSize: "12px",fontStyle: "normal",fontWeight: "500",lineHeight: "20px"}}></span> */}
        </div>
      </div>
      <div className="popuppagination-numbers">
        {renderPageNumbers()}
      </div>
      <div className="popuppagination-controls">
        <div
          className={`popuppagination-control ${currentPopupPage === totalPopupPages ? 'disabled' : ''}`}
          onClick={handleNextClick}
        >
          {/* <span style={{color: "#4B628A",
fontFamily: "Inter",
fontSize: "12px",
fontStyle: "normal",
fontWeight: "500",
lineHeight: " 20px"}}>Next</span> */}
          <img className='right-arrow' src={rightarrow} alt="rightarrow" />
        </div>
      </div>
      </div>

    </div>
    
  );
};

  export default UsersPopupPagination;